export default {
  "content": "<path d=\"M8.803 3.633c0-.35.285-.635.636-.635h5.772l5.359 5.09H8.803V3.633zM20.364 8.8c.354 0 .636.283.636.635l-.002 5.771-5.087 5.361V8.8h4.454zM14.562 21.002c.35 0 .635-.285.635-.636v-4.453H3.43l5.36 5.088 5.772.001zM3.636 15.194A.637.637 0 013 14.557V8.786l5.089-5.36v11.768H3.636z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};